import React from 'react';
import { Box } from '../design/css';
import Table from '../design/shared/table';
import { camel2title } from '../utils/utils';

const OrderEquipments = (OrderEquipmentModel, data, labels) => {
  const locale = localStorage.getItem('locale');
  if (!(data && data.length && labels)) return null;

  const updatedData = data.map(item => {
    const result = item;
    result.product_name = camel2title(result.product_name);
    return result;
  });
  const included = updatedData.filter(item => item.type === 'Included');
  const additional = updatedData.filter(item => item.type === 'Additional');
  const orderEquipmentLables = {
    includedEquipments:
      locale === 'FR' ? 'Équipement inclus' : 'Included Equipments',
    additionalEquipments:
      locale === 'FR' ? 'Équipement additionnel' : 'Additional Equipments'
  };
  const orderEquipments = {
    includedEquipments: included,
    additionalEquipments: additional
  };

  const tableHeaders = new OrderEquipmentModel(labels);

  return Object.keys(orderEquipments).map(equipmentType => {
    return (
      !!orderEquipments[equipmentType].length && (
        <Box pr={24} pl={24} width={40} mdWidth={100} pb={12}>
          <Box pt={12}>
            <Table
              title={orderEquipmentLables[equipmentType]}
              headers={tableHeaders}
              data={orderEquipments[equipmentType]}
              keys={Object.keys(tableHeaders)}
              totalRecords={orderEquipments[equipmentType].length}
            />
          </Box>
        </Box>
      )
    );
  });
};

export default OrderEquipments;
